import Heading from 'components/Heading/Heading';
import i18Next from 'i18next';
import Lottie from 'react-lottie';
import LoadingAnimation from 'assets/lottie/loading.json';
import styles from './LoadingScreen.module.scss';
import H1 from 'components/H/H1';

type Props = {
  title?: string;
  subTitle?: string;
};

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: LoadingAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
export default function LoadingScreen({
  title = i18Next.t('loading_screen:title'),
  subTitle = i18Next.t('loading_screen:subtitle'),
}: Props) {
  return (
    <div className={styles.wrapper} data-test="loadingScreen">
      <div className={styles.lottie} data-test="loadingScreen-lottie-wrapper">
        <Lottie
          data-test="loadingScreen-lottie"
          height={200}
          options={lottieOptions}
        />
      </div>
      <H1
        className="mt-3 mb-5 lg:text-[32px] text-[27px] font-extrabold"
        dataTest="loadingScreen-title"
      >
        {title}
      </H1>
      <Heading
        className={styles.subtitle}
        size="s"
        dataTest="loadingScreen-subtitle"
      >
        {subTitle}
      </Heading>
    </div>
  );
}
